import {tns} from "tiny-slider";

export default () => ({

    init() {
        
        tns({
            mode: 'gallery',
            container: this.$el,
            autoplayTimeout: 3500,
            // slideBy: 'page',
            autoplayButtonOutput: false,
            autoplay: true,
            nav: false,
            controls: false,
            // prevButton: false,
            // nextButton: false
            // lazyload: true,
        });

    }
    
});
